var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44704 0.860596H22.5529C22.8861 0.860596 23.2058 0.986525 23.4414 1.21068C23.6771 1.43484 23.8095 1.73886 23.8095 2.05586V3.95156C23.8094 4.26854 23.677 4.57251 23.4413 4.79661L15.3814 12.4631C15.1457 12.6872 15.0133 12.9911 15.0132 13.3081V20.8443C15.0132 21.026 14.9696 21.2053 14.8858 21.3685C14.8021 21.5318 14.6802 21.6748 14.5297 21.7866C14.3791 21.8983 14.2037 21.976 14.0168 22.0136C13.8299 22.0512 13.6365 22.0478 13.4512 22.0037L10.938 21.4061C10.6662 21.3413 10.425 21.192 10.2527 20.982C10.0803 20.7719 9.98673 20.5131 9.98673 20.2466V13.3081C9.98666 12.9911 9.85422 12.6872 9.61854 12.4631L1.55862 4.79661C1.32294 4.57251 1.1905 4.26854 1.19043 3.95156V2.05586C1.19043 1.73886 1.32282 1.43484 1.55848 1.21068C1.79414 0.986525 2.11377 0.860596 2.44704 0.860596Z",
    stroke: "white",
    strokeWidth: 1.41183,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.bf09f19786b42af231644d20499a3cc6.svg";
export { ForwardRef as ReactComponent };